import React from 'react';

const InfoInput = ({ name, value, onChange, disabled, placeholder, label, id, className }) => {
  if (label) {
    return (
      <label className={`m-1 flex w-full justify-center items-center ${className || ''}`}>
        <span className="mr-1">{label}</span>
        <input
          className="font-bold w-full p-1 border-none rounded-md disabled:bg-white disabled:text-black"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={(e) => onChange(e, id)}
          disabled={disabled}
        />
      </label>
    );
  }

  return (
    <input
      className={`m-1 p-1 rounded-md border-none font-bold disabled:bg-white disabled:text-black ${className || ''}`}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={(e) => onChange(e, id)}
      aria-label={placeholder}
      disabled={disabled}
    />
  );
};

export default InfoInput;